import { ChangeDetectionStrategy, Component, Input, OnInit, Output } from '@angular/core';
import { DiagnosticOrderActionsService } from '@ispm/test/services/diagnostic-order-actions.service';
import { IDiagnosticOrder, IRevision } from '@ispm/test/interfaces/diagnostic-order.interface';
import { Subject } from 'rxjs/Subject';
import { TestActionsService } from '@ispm/test/services/test-actions.service';
import { ConfirmModalComponent } from '../../../../layout/components/modals/confirm-modal/confirm-modal.component';
import { DynamicModalLoaderService } from '../../../../layout/services/dynamic-modal-loader.service';
import { ModalTypes } from '../../../../layout/components/modals/contants/modal-types.enum';
import { CoreActionCreatorService } from '@ispm/core/services/core-action-creator.service';
import { NOTIFICATION_MESSAGE } from "@ispm-client/modules/aggregator/services/consts";
import { DiagnosticOrderService } from '../../services/diagnostic-order.service';
import { TestService } from '../../services/test.service';
import { WorkflowService } from '@ispm/workflow/services/workflow.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import { RouterManagerService } from "@ispm/core/services/router-manager.service";

@Component({
  selector: 'gen-data-collection-tab',
  templateUrl: './data-collection-tab.component.html',
  styleUrls: ['./data-collection-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class DataCollectionTabComponent implements OnInit {

  @Input() finishWorkflowStep: boolean = true;
  @Output() submitted: boolean = false;

  public formsConfig: any[] = [];
  public formName: string;
  public currentTest: IDiagnosticOrder;
  public  changedFields: any = {};

  private defaultFieldValues: any = {};
  private currentRevision: IRevision;
  private destroyed$: Subject<any> = new Subject();
  private testConfiguration: any;
  private revisionId: string;
  private activeJob: any;
  private inputs: any[];

  constructor(private diagnosticOrderActionsService: DiagnosticOrderActionsService,
              private testService : TestService,
              private diagnosticOrderService : DiagnosticOrderService,
              private workflowService: WorkflowService,
              private testActionsService: TestActionsService,
              private notificationMessageService: NotificationMessageService,
              private notificationMessage: NOTIFICATION_MESSAGE,
              private dynamicModalLoader: DynamicModalLoaderService,
              private coreActionCreator: CoreActionCreatorService,
              private routerManagerService: RouterManagerService) {
  }

  ngOnInit() {

    this.revisionId = this.routerManagerService.parameters?.revisionId;
    const testConfiguration = this.testService.testConfiguration;

    if (testConfiguration) {
      const additionalFormsConfig = Array.isArray(testConfiguration.additionalDataFormsConfig) ? testConfiguration.additionalDataFormsConfig : [];
      this.testConfiguration = testConfiguration;

      this.diagnosticOrderActionsService.getState()
        .filter(state => !!state.order && Object.keys(state.order).length > 0)
        .map(state => state.order)
        .takeUntil(this.destroyed$.asObservable())
        .subscribe(order => {
          this.currentTest = order;
          this.currentRevision = order.workflowRequest.revisions.find(rev => rev.id === this.revisionId);
          this.activeJob = this.currentRevision.items.find(item => item.name === this.currentTest.workflowRequest.activeJobName);
          if (this.activeJob) {
            this.inputs = this.activeJob['inputs'];
            this.formsConfig = [];
            if (this.inputs.length && this.inputs.length > 0) {
              this.inputs.forEach(input => {
                if (input.type === 'formName') {
                  const foundFormDescr = additionalFormsConfig.find(item => item.key === input.key);

                  this.formsConfig.push(foundFormDescr);
                }
              });
            }
          }
        });
    }

  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  formChanged(form, updateFieldKeys: any) {
    for (const key of updateFieldKeys) {
      this.changedFields[key] = form[key];
    }
  }

  formInit(form: any) {

    this.changedFields = { };
    this.defaultFieldValues = { };

    for (const key of Object.keys(form)) {
      this.defaultFieldValues[key] = form[key];
      this.changedFields[key] = form[key];
    }
  }

  submitForm(model) { }
  cancelForm(model) { }

  // trackByFormId(formConfig: any): string {
  //   return formConfig.formId;
  // }

  submit() {
    this.submitted = true;
    const updatedProperties = [];
    let foundUndefined = false;
    for (const field in this.changedFields) {
        this.currentTest[field] = this.changedFields[field];
        foundUndefined = this.changedFields[field] == null;
        updatedProperties.push(field);
    }
    if (!foundUndefined) {
      this.updateDiagnosticOrder('diagnosticOrder', updatedProperties);

      if (this.finishWorkflowStep) {
          const activeJob = this.currentRevision.items.find(val => val.name === this.currentTest.workflowRequest.activeJobName);
          this.performWorkflowStepByStepName(activeJob.name, undefined);
      }
    }
    else {
      this.dynamicModalLoader.popupModal(ConfirmModalComponent,
        {
          title: 'Error',
          content: 'Not all question are answered. Please select answers for all questions',
          approveBtn: 'Close',
          declineBtn: ''
        }, ModalTypes.ALERT).subscribe((response) => {
      });
    }
    }

  private performWorkflowStepByStepName (stepName, inputButtonArgs) {
    this.coreActionCreator.setLoader(true);
    this.workflowService.performWorkflowStep(this.currentTest, stepName, null, this.routerManagerService.parameters?.revisionId, null, null, inputButtonArgs)
      .then(() => {
        this.notificationMessageService.success(this.notificationMessage.SUCCESSFULLY_MOVED_TO_NEXT_STEP);
        this.routerManagerService.reload();
        this.coreActionCreator.setLoader(false);
      })
      .catch(() => {
        this.notificationMessageService.error(this.notificationMessage.UNABLE_TO_MOVE_TO_THE_NEXT_STEP);
        this.coreActionCreator.setLoader(false);
      });
  }


  private updateDiagnosticOrder(updateResourceName: string, updatedField: string[]): void {
    this.testActionsService.updateTestInfo(this.diagnosticOrderService.formalizeForServer(this.currentTest), this.revisionId, updateResourceName, updatedField)
      .subscribe(newTest => {
        if (!newTest) { return; }
        this.currentTest = newTest;
        this.diagnosticOrderActionsService.setDiagnosticOrder(newTest);
      });
  }

}
